import React, { memo, useMemo, useCallback } from 'react';
import { FormSelect } from '@core/components/form';
import { useObservable } from '@core/utils/hooks/rxjs';
import { useBloc } from '@core/utils/bloc';
import { CommonService } from '@business/services';
import { FlowChartBlockWidgetForm, FlowChartBlockVariation } from './FlowChartBlock';
import { FlowChartBlockBloc } from './FlowChartBlockBloc';
import { R } from '@core/utils/r';

export interface FlowChartBlockSettingsProps {
  form: FlowChartBlockWidgetForm;
  variation: FlowChartBlockVariation;
  onFormChange(content: string): void;
}

export const FlowChartBlockSettings = memo((props: FlowChartBlockSettingsProps) => {
  const { form, variation, onFormChange } = props;
  const bloc = useBloc(FlowChartBlockBloc, variation);
  const data = useObservable(bloc.items$);
  const items = useMemo(() => CommonService.selectItems(data || [], 'name', 'id'), [data]);

  const onChange = useCallback(
    (value: string) => {
      const chart = R.find(data, i => i.id == value);
      if (chart) {
        onFormChange(chart.content as string);
        form.patchValue({ text: chart.content as string, heading: chart.name as string });
      }
    },
    [data, form, onFormChange],
  );

  return (
    <div>
      <FormSelect control={form.controls.id} items={items} onChange={onChange} />
    </div>
  );
});
